import React from 'react';
import { Dialog, Stack, ButtonGroup, Button } from '@material-ui/core';
import ZoomInRoundedIcon from '@mui/icons-material/ZoomInRounded';
import ZoomOutRoundedIcon from '@mui/icons-material/ZoomOutRounded';
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
const ZoomDialog = ({ open, onClose, imageUrl }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <TransformWrapper initialScale={1} initialPositionX={0} initialPositionY={0}>
        {({ zoomIn, zoomOut, resetTransform }) => (
          <Stack
            style={{
              maxHeight: '95vh'
            }}
          >
            <Stack
              className="tools"
              style={{
                width: '100%',
                backgroundColor: 'white',
                padding: '1rem'
              }}
              justifyContent="space-between"
              direction="row"
              fullWidth
            >
              <ButtonGroup>
                <Button
                  onClick={() => zoomIn()}
                  variant="contained"
                  startIcon={<ZoomInRoundedIcon />}
                >
                  Zoom In
                </Button>
                <Button
                  onClick={() => zoomOut()}
                  variant="contained"
                  startIcon={<ZoomOutRoundedIcon />}
                >
                  Zoom Out
                </Button>

                <Button
                  onClick={() => resetTransform()}
                  variant="contained"
                  startIcon={<RestartAltRoundedIcon />}
                >
                  Reset
                </Button>
              </ButtonGroup>
              <Button
                onClick={() => onClose()}
                variant="outlined"
                style={{
                  backgroundColor: 'white'
                }}
                startIcon={<CloseRoundedIcon />}
              >
                Close
              </Button>
            </Stack>
            <Stack
              style={
                {
                  // height: '85vh'
                }
              }
            >
              <TransformComponent>
                <img src={imageUrl} alt="Zoomed In Image" style={{ height: '85vh' }} />
              </TransformComponent>
            </Stack>
          </Stack>
        )}
      </TransformWrapper>
    </Dialog>
  );
};

export default ZoomDialog;
